import { render, staticRenderFns } from "./Socios.vue?vue&type=template&id=75f2d09a&scoped=true&"
import script from "./Socios.vue?vue&type=script&lang=ts&"
export * from "./Socios.vue?vue&type=script&lang=ts&"
import style0 from "./Socios.vue?vue&type=style&index=0&id=75f2d09a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f2d09a",
  null
  
)

export default component.exports